<template>
  <v-card class="common-card-panel">
    <Multi />
    <Single />
  </v-card>
</template>

<script>
import Multi from "./Multi";
import Single from "./Single";
export default {
  name: "PreviewShop",
  components: {
    Multi,
    Single,
  },
  data() {
    return {};
  },
};
</script>
